import radio from './radio.vue'

export default radio
